
const newModel = () => {
    return {
        atmId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tenPhuongXa: null,
        phuongXaId: null,
        nganHangId: null,
        tenNganHang: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        soMay: null,
        ghiChu: null,
        stt: null,
        enabled: null, 
        dateCreated: null,
        userCreated: null, 
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        atmId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        phuongXaId: null,
        nganHangId: null,
        gpsLong: null,
        gpsLat: null,
        soMay: null,
        ghiChu: null,
        stt: "0",
        enabled: true
    }
}

const fromJson = (item) => {
    return {
        atmId: item.atmId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        nganHangId: item.nganHangId,
        tenNganHang: item.tenNganHang,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        soMay: item.soMay,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,

    }
}

const parseModeltoFEModel = (item) => {
    return {
        atmId: item.atmId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        phuongXaId: item.phuongXaId,
        nganHangId: item.nganHangId,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        soMay: item.soMay,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        phuongXaId: null,
        nganHangId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        phuongXaId: item.phuongXaId,
        nganHangId: item.nganHangId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        atmId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        phuongXaId: null,
        nganHangId: null,
        gpsLong: null,
        gpsLat: null,
        soMay: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}


export const atmModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


